import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CreateLeasingForm } from "web_myplann/Portfolio/Pages/LeasingCreate/CreateLeasingForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

export const AddLeasingPage = () => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddLeasing.title)}>
			<CreateLeasingForm />
		</PortfolioAddLayout>
	);
};
